enum CardRoutes {
  FlexiPoints = "flexi-points",
  RewardPoints = "reward-points",
  CustomRewards = "custom-rewards",
  Cash = "cash",
  Cashback = "cashback"
}

export default CardRoutes
